import Mosaic from 'mosaic-framework';

import '../styles/footer.less';


export default new Mosaic({
    name: 'app-footer',
    view() {
        return html`<div>
            <h4>
                Released under the MIT License
                <br>
                Copyright © 2019-Present Adeola Uthman
            </h4>
        </div>`
    }
})